import { Card, CardContent, Divider } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ClientListSkeletonMobile = () => (
  <>
    {[...Array(2)].map((row, i) => (
       <Card key={i} variant="outlined" sx={{ mb: 2, opacity: 0.6, position: "relative" }}>
      <CardContent>
        <div className="flex items-center gap-3 mb-2" style={{ display: "flex", gap: "10px" }}>
          <Skeleton variant="circular" width={50} height={50} />

          <div>
            {/* Name Skeleton */}
            <Skeleton variant="text" width={120} height={28} />
            {/* Preferred Name Skeleton */}
            <Skeleton variant="text" width={160} height={20} sx={{ mt: 1 }} />
          </div>
        </div>

        <Divider />

        <div
          style={{
            width: "auto",
            marginTop: "10px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <div style={{ marginTop: "10px" }}>
              <Skeleton variant="rectangular" width={200} height={40} />
            </div>

            <Skeleton variant="text" width={100} height={20} sx={{ mt: 2, ml: 1 }} />
          </div>

          <div className="flex gap-2 mt-2">
            <Skeleton variant="circular" width={35} height={35} />
          </div>
        </div>

        <div className={`dialog_items right-1 mt-12 left-150`} style={{ bottom: "0" }}>
          <Skeleton variant="rectangular" width={120} height={35} sx={{ mt: 2 }} />
          <Skeleton variant="rectangular" width={120} height={35} sx={{ mt: 1 }} />
        </div>
      </CardContent>
    </Card>
    ))}
  </>
);

export default ClientListSkeletonMobile;
